import { Button, CircularProgress, Typography } from '@material-ui/core';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import PublicLayout from 'v2/components/Shared/PublicLayout';
import GlpiTicketApprovalService from 'v2/services/glpiTicketApproval';

import type { IGlpiPayload, IObservation } from 'v2/interfaces/glpiTicketApproval';

import { useStyles } from './styles';
import TextField from './TextField';
import ThankyouPage from './ThankyouPage';
import validation from './validation';

const GlpiApproval = () => {
  const qs = new URLSearchParams(window.location.search);
  const id = Number(qs.get('id'));
  const ticket_title = qs.get('name');
  const solvedate = qs.get('solvedate');
  const ticket_status = qs.get('status');

  const initialValues: IObservation = {
    observation: '',
  };

  useEffect(() => {
    if (ticket_status == '6') {
      handleApprove();
    }
    //eslint-disable-next-line
  }, []);

  const classes = useStyles();
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [status, setStatus] = useState<'approved' | 'reproved' | null>(null);
  const [message, setMessage] = useState('');
  const [approving, setApproving] = useState(false);
  const [reproving, setReproving] = useState(false);

  const handleApprove = async () => {
    const payload: IGlpiPayload = { action: 'approve', solvedate, ticket_title };
    try {
      setApproving(true);
      const { data } = await GlpiTicketApprovalService.moderateTicket(id, payload);
      setApproving(false);
      if (!data?.success) {
        setMessage(data?.message);
      }
    } finally {
      setIsSubmitted(true);
      setStatus('approved');
    }
  };

  const handleReprove = async (observation: IObservation) => {
    const payload: IGlpiPayload = { ...observation, action: 'reprove', solvedate, ticket_title };
    try {
      setReproving(true);
      const { data } = await GlpiTicketApprovalService.moderateTicket(id, payload);
      setReproving(false);
      if (!data?.success) {
        setMessage(data?.message);
      }
    } finally {
      setIsSubmitted(true);
      setStatus('reproved');
    }
  };

  return (
    <PublicLayout>
      {!isSubmitted && (
        <div className={classes.center}>
          <Typography variant='subtitle1'>Para que a solução do chamado seja reprovada, é necessário deixar um comentário.</Typography>
          <Formik initialValues={initialValues} validationSchema={validation} onSubmit={(observation: IObservation) => handleReprove(observation)}>
            <Form>
              <TextField />
              <Button disabled={reproving} variant='outlined' color='secondary' type='submit' className={classes.reproveButton}>
                Reprovar Chamado
                {reproving && (
                  <span style={{ marginLeft: 12, position: 'relative', top: 1 }}>
                    <CircularProgress size={16} style={{ color: '#596375' }} />
                  </span>
                )}
              </Button>
            </Form>
          </Formik>
          <div className={classes.approveContent}>
            <Typography variant='subtitle1'>Caso o chamado tenha sido solucionado, aprove clicando no botão abaixo.</Typography>
            <Button variant='contained' disabled={approving} color='secondary' className={classes.approveButton} onClick={handleApprove}>
              Aprovar Chamado
              {approving && (
                <span style={{ marginLeft: 12, position: 'relative', top: 1 }}>
                  <CircularProgress size={16} style={{ color: '#596375' }} />
                </span>
              )}
            </Button>
          </div>
        </div>
      )}
      {isSubmitted && (
        <div className={classes.center}>
          <ThankyouPage status={status} message={message} />
        </div>
      )}
    </PublicLayout>
  );
};

export default GlpiApproval;
